// TODO
export const prefix = 'tdesign-starter';
export const TOKEN_NAME = 'tdesign-starter';
export const IEG_SPD_IT_HELPER = 'wxwork://message?uin=8444251297321381';
export const PROJECT_NAME = 'supplier-video';
